import { ChevronRight } from 'lucide-react'

import { cn } from '@/lib/ui/style-helpers'

type GroupHeaderCellProps = {
  label: string
  isExpanded: boolean
  onToggle?: () => void
  className?: string
}

export const GroupHeaderCell = ({
  label,
  isExpanded,
  onToggle,
  className,
}: GroupHeaderCellProps) => {
  return (
    <div
      role={onToggle ? 'button' : undefined}
      tabIndex={onToggle ? 0 : undefined}
      onClick={onToggle}
      className={cn(
        'hover:bg-main-background-subtle flex size-full cursor-pointer items-center gap-1.5 text-main-foreground-primary text-body-small',
        className,
      )}
    >
      {label}
      <ChevronRight
        className={cn(
          'size-4 text-main-foreground-tertiary transition-transform',
          isExpanded && 'rotate-90',
        )}
      />
    </div>
  )
}
